import React, {useRef,useState,Fragment} from 'react';
import {ThemeProvider} from 'styled-components';
import {theme} from '../../styles/theme';
// import DreamExLogo from '../DreamExLogo/DreamExLogo';
import dxConnectLogoGrey from '../../images/dxConnectLogoGrey.png'
import {useOutsideClick} from '../../hooks/useOutsideClick';
import {
  Wrapper,
  Hamburger,
  Line,
  Dropdown,
  DropItem,
  LogoWrapper,
  SignOut,
  Copyright
} from './MobileNavStyles';
import {Auth} from 'aws-amplify';


const MobileNav = ({navItems}) => {
  const [dropdown,setDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useOutsideClick(dropdownRef,() => setDropdown(false));

  async function handleSignout() {
    try {
      await Auth.signOut()
    } catch(err) {
      console.error('Error signing out user',err);
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Fragment>
        <Wrapper>
          <LogoWrapper>
            <img width={120} color='#555' src={dxConnectLogoGrey} alt='DreamEx Connect' />
            {/* <DreamExLogo width={120} color='#555' /> */}
          </LogoWrapper>
          <Hamburger
            ref={dropdownRef}
            onClick={() => setDropdown(!dropdown)}
          >
            <Line/>
            <Line/>
            <Line/>
            {dropdown && (<Dropdown>
              {navItems.map(item => (
                <DropItem
                  key={`link_${item.title}`}
                  to={item.link}
                  exact={item.exact ? 1 : 0}
                >{item.title}</DropItem>
              ))}
              <SignOut onClick={handleSignout}>SIGN OUT</SignOut>
              <Copyright>&copy; 2020 Dream Exchange LLC</Copyright>
            </Dropdown>)}
          </Hamburger>
        </Wrapper>
      </Fragment>
    </ThemeProvider>
  );
};

export default MobileNav;
